import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const RouteTitleUpdater = () => {
    const location = useLocation();

    useEffect(() => {
        switch (location.pathname) {
            case '/':
                document.title = 'Главная — Такса House';
                break;
            case '/auth/login':
                document.title = 'Вход — Такса House';
                break;
            case '/auth/registration':
                document.title = 'Регистрация — Такса House';
                break;
            case '/auth/logout':
                document.title = 'Выполняется выход — Такса House';
                break;
            case '/account':
                document.title = 'Админ-панель — Такса House';
                break;
            case '/clients':
                document.title = 'Клиенты — Такса House';
                break;
            case '/users':
                document.title = 'Пользователи — Такса House';
                break;
            case '/rooms':
                document.title = 'Квартиры — Такса House';
                break;
            case '/room-list':
                document.title = 'Доступные квартиры — Такса House';
                break;
            default:
                document.title = 'Такса House';
        }
    }, [location]);

    return null;
};

export default RouteTitleUpdater;
